'use strict';

var SCRIPT_ID = 'google-places-autocomplete-js';
var placesScriptPromise = null;

function readConfig(formGroup) {
    var enabled = String(formGroup.getAttribute('data-places-enabled') || '').toLowerCase() === 'true';
    var apiKey = (formGroup.getAttribute('data-places-api-key') || '').trim();
    var minChars = parseInt(formGroup.getAttribute('data-places-min-chars'), 10);
    var allowedCountries = (formGroup.getAttribute('data-places-allowed-countries') || '')
        .split(',')
        .map(function (code) {
            return code.trim().toLowerCase();
        })
        .filter(Boolean);

    return {
        enabled: enabled,
        apiKey: apiKey,
        minChars: !isNaN(minChars) && minChars > 0 ? minChars : 1,
        allowedCountries: allowedCountries
    };
}

function isPlacesReady() {
    return !!(window.google
        && window.google.maps
        && window.google.maps.places
        && typeof window.google.maps.places.Autocomplete === 'function');
}

function loadGooglePlaces(apiKey) {
    if (isPlacesReady()) {
        return Promise.resolve();
    }

    if (placesScriptPromise) {
        return placesScriptPromise;
    }

    placesScriptPromise = new Promise(function (resolve, reject) {
        var existing = document.getElementById(SCRIPT_ID);
        if (existing) {
            var waitForExisting = function (attempts) {
                if (isPlacesReady()) {
                    resolve();
                    return;
                }
                if (attempts <= 0) {
                    placesScriptPromise = null;
                    reject(new Error('Places library not available after script load'));
                    return;
                }
                setTimeout(function () {
                    waitForExisting(attempts - 1);
                }, 100);
            };
            waitForExisting(50);
            return;
        }

        var script = document.createElement('script');
        script.id = SCRIPT_ID;
        script.async = true;
        script.defer = true;
        script.src = 'https://maps.googleapis.com/maps/api/js?key='
            + encodeURIComponent(apiKey)
            + '&libraries=places&v=weekly';
        script.onload = function () {
            var attempts = 50;
            var poll = function () {
                if (isPlacesReady()) {
                    resolve();
                    return;
                }
                attempts -= 1;
                if (attempts <= 0) {
                    placesScriptPromise = null;
                    reject(new Error('Places library not available after script load'));
                    return;
                }
                setTimeout(poll, 100);
            };
            poll();
        };
        script.onerror = function () {
            placesScriptPromise = null;
            reject(new Error('Places script failed to load'));
        };
        document.head.appendChild(script);
    });

    return placesScriptPromise;
}

function getSelectedCountry(formRoot) {
    var countrySelect = formRoot.querySelector('.shippingCountrySelect');
    if (!countrySelect) {
        return '';
    }

    var selectedOption = null;

    if (window.jQuery) {
        var $selected = window.jQuery(countrySelect).find('option:selected').first();
        if ($selected.length) {
            selectedOption = $selected.get(0);
        }
    }

    if (!selectedOption && countrySelect.options && countrySelect.selectedIndex >= 0) {
        selectedOption = countrySelect.options[countrySelect.selectedIndex];
    }

    var code = '';
    if (selectedOption) {
        code = selectedOption.id || selectedOption.value || '';
    }
    if (!code) {
        code = countrySelect.value || '';
    }

    return String(code).toLowerCase();
}

function buildCountryRestriction(allowedCountries, selectedCountry) {
    if (selectedCountry) {
        if (!allowedCountries.length || allowedCountries.indexOf(selectedCountry) !== -1) {
            return { country: selectedCountry };
        }
    }

    if (!allowedCountries.length) {
        return null;
    }

    if (allowedCountries.length === 1) {
        return { country: allowedCountries[0] };
    }

    return { country: allowedCountries.slice(0, 5) };
}

function applyCountryRestriction(autocomplete, formRoot, config) {
    if (!autocomplete) {
        return;
    }

    var nextRestriction = buildCountryRestriction(
        config.allowedCountries,
        getSelectedCountry(formRoot)
    );

    if (nextRestriction) {
        autocomplete.setComponentRestrictions(nextRestriction);
    }
}

function getAddressComponent(components, type, shortName) {
    if (!components || !components.length) {
        return '';
    }

    for (var i = 0; i < components.length; i++) {
        var component = components[i];
        if (component.types && component.types.indexOf(type) !== -1) {
            return shortName ? component.short_name : component.long_name;
        }
    }

    return '';
}

function setFieldValue(el, value) {
    if (!el || value === undefined) {
        return;
    }

    el.value = value;
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));

    if (value === null || value === '') {
        return;
    }
    if (el.classList) {
        el.classList.add('is-filled');
    }
}

function setStateValue(formRoot, stateName) {
    if (!stateName) {
        return;
    }

    var stateInput = formRoot.querySelector('.state');
    var selectedText = formRoot.querySelector('.shipping-state-dropdown .selected-text');
    var stateDropdown = formRoot.querySelector('.shipping-state-dropdown');
    var listItems = formRoot.querySelectorAll('.shipping-state-dropdown .dropdown-list li');
    var matched = '';

    if (listItems && listItems.length) {
        for (var i = 0; i < listItems.length; i++) {
            var text = (listItems[i].textContent || '').trim();
            if (!text) {
                continue;
            }
            if (text.toLowerCase() === stateName.toLowerCase()  || removeAccents(text.toLowerCase()) === stateName.toLowerCase()) {
                matched = text;
                break;
            }
        }
    }
     
    setFieldValue(stateInput, matched);

    if (selectedText) {
        selectedText.textContent = matched;
    }

    if (stateDropdown) {
        stateDropdown.setAttribute('data-last-selected-text', matched);
    }
}

function setCountryValue(formRoot, countryCode) {
    if (!countryCode) {
        return;
    }

    var countrySelect = formRoot.querySelector('.shippingCountrySelect');
    if (!countrySelect) {
        return;
    }

    var upper = countryCode.toUpperCase();
    var option = countrySelect.querySelector('option[value="' + upper + '"], option[id="' + upper + '"]');

    if (option) {
        countrySelect.value = option.value;
        countrySelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
}

function waitForStateOptions(formRoot, callback) {
    var attempts = 0;
    var timer = setInterval(function () {
        attempts += 1;
        var items = formRoot.querySelectorAll('.shipping-state-dropdown .dropdown-list li');
        var hasRealOptions = false;

        for (var i = 0; i < items.length; i++) {
            if (!items[i].classList.contains('dropdown-list__no-data-available')
                && (items[i].textContent || '').trim()
                && (items[i].textContent || '').toLowerCase().indexOf('no states') === -1) {
                hasRealOptions = true;
                break;
            }
        }

        if (hasRealOptions || attempts > 25) {
            clearInterval(timer);
            callback();
        }
    }, 100);
}

function setCountryAndState(formRoot, countryCode, stateName) {
    var countrySelect = formRoot.querySelector('.shippingCountrySelect');
    var currentCountry = countrySelect ? String(countrySelect.value || '').toUpperCase() : '';
    var nextCountry = countryCode ? String(countryCode).toUpperCase() : '';

    if (nextCountry && countrySelect && currentCountry !== nextCountry) {
        setCountryValue(formRoot, nextCountry);
        waitForStateOptions(formRoot, function () {
            setStateValue(formRoot, stateName);
        });
        return;
    }

    setStateValue(formRoot, stateName);
}

function removeAccents(str) {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

function fillAddressFields(formRoot, place) {
    var components = place.address_components || [];
    var streetNumber = getAddressComponent(components, 'street_number', false);
    var route = getAddressComponent(components, 'route', false);
    var subpremise = getAddressComponent(components, 'subpremise', false);
    var neighborhood = getAddressComponent(components, 'neighborhood', false);
    var sublocality = getAddressComponent(components, 'sublocality_level_1', false)
        || getAddressComponent(components, 'sublocality', false);
    var city = getAddressComponent(components, 'locality', false)
        || getAddressComponent(components, 'postal_town', false)
        || getAddressComponent(components, 'administrative_area_level_2', false);
    var state = getAddressComponent(components, 'administrative_area_level_1', false);
    var postalCode = getAddressComponent(components, 'postal_code', false);
    var country = getAddressComponent(components, 'country', true);

    var address1 = [streetNumber, route,subpremise, sublocality, neighborhood].filter(Boolean).join(', ').trim();
    address1 = removeAccents(address1);
    city = removeAccents(city);
    state = removeAccents(state);

    setFieldValue(formRoot.querySelector('.shippingAddressOne'), address1);
    setFieldValue(formRoot.querySelector('.city'), city);
    setFieldValue(formRoot.querySelector('.zipcode'), postalCode);
    setCountryAndState(formRoot, country, state);
}

function hidePacContainers() {
    var pacContainers = document.querySelectorAll('.pac-container');
    for (var i = 0; i < pacContainers.length; i++) {
        pacContainers[i].classList.add('places-minchars-hide');
        pacContainers[i].style.display = 'none';
    }
}

function bindMinCharsGuard(input, minChars) {
    var selectionLock = false;

    var syncVisibility = function () {
        var pacContainers = document.querySelectorAll('.pac-container');
        var show = !selectionLock
            && document.activeElement === input
            && (input.value || '').trim().length >= minChars;

        for (var i = 0; i < pacContainers.length; i++) {
            if (show) {
                pacContainers[i].classList.remove('places-minchars-hide');
                pacContainers[i].style.display = '';
            } else {
                pacContainers[i].classList.add('places-minchars-hide');
                pacContainers[i].style.display = 'none';
            }
        }
    };

    var unlock = function () {
        selectionLock = false;
    };

    var lockAfterSelect = function () {
        selectionLock = true;
        hidePacContainers();
    };

    input.addEventListener('input', function () {
        selectionLock = false;
        syncVisibility();
    });
    input.addEventListener('keyup', syncVisibility);
    input.addEventListener('keydown', syncVisibility);
    input.addEventListener('focus', syncVisibility);
    input.addEventListener('blur', function () {
        hidePacContainers();
    });

    if (typeof MutationObserver !== 'undefined') {
        var observer = new MutationObserver(syncVisibility);
        observer.observe(document.body, { childList: true });
    }

    syncVisibility();

    return {
        lockAfterSelect: lockAfterSelect,
        unlock: unlock
    };
}

function suppressGooglePlaceholder(input) {
    var applyBlankPlaceholder = function () {
        if (input.getAttribute('placeholder') !== ' ') {
            input.setAttribute('placeholder', ' ');
        }
    };

    applyBlankPlaceholder();
    input.addEventListener('focus', applyBlankPlaceholder);
    input.addEventListener('blur', applyBlankPlaceholder);

    setTimeout(applyBlankPlaceholder, 0);
    setTimeout(applyBlankPlaceholder, 150);
    setTimeout(applyBlankPlaceholder, 500);

    if (typeof MutationObserver !== 'undefined') {
        var observer = new MutationObserver(applyBlankPlaceholder);
        observer.observe(input, { attributes: true, attributeFilter: ['placeholder'] });
    }
}

function attachAutocomplete(input, formRoot, config) {
    if (input.getAttribute('data-places-bound') === 'true') {
        return;
    }

    if (!isPlacesReady()) {
        return;
    }

    input.setAttribute('autocomplete', 'off');
    input.setAttribute('autocorrect', 'off');
    input.setAttribute('autocapitalize', 'off');
    input.setAttribute('spellcheck', 'false');
    suppressGooglePlaceholder(input);

    var options = {
        fields: ['address_components', 'formatted_address', 'name'],
        types: ['address']
    };

    var restriction = buildCountryRestriction(config.allowedCountries, getSelectedCountry(formRoot));
    if (restriction) {
        options.componentRestrictions = restriction;
    }

    var autocomplete = new window.google.maps.places.Autocomplete(input, options);
    var minCharsGuard = bindMinCharsGuard(input, config.minChars);

    suppressGooglePlaceholder(input);

    autocomplete.addListener('place_changed', function () {
        var place = autocomplete.getPlace();
        if (!place || !place.address_components) {
            return;
        }
        minCharsGuard.lockAfterSelect();
        fillAddressFields(formRoot, place);
        hidePacContainers();
        suppressGooglePlaceholder(input);
        input.blur();
    });

    input.addEventListener('input', function () {
        applyCountryRestriction(autocomplete, formRoot, config);
    });
    input.addEventListener('focus', function () {
        applyCountryRestriction(autocomplete, formRoot, config);
    });

    var onCountryChange = function () {
        setTimeout(function () {
            applyCountryRestriction(autocomplete, formRoot, config);
        }, 0);
    };

    var countrySelect = formRoot.querySelector('.shippingCountrySelect');
    if (countrySelect) {
        countrySelect.addEventListener('change', onCountryChange);
    }

    if (window.jQuery) {
        window.jQuery(formRoot)
            .off('change.placesAutocomplete')
            .on(
                'change.placesAutocomplete',
                '.shippingCountrySelect, .countrySelector select, .countryCodeSelector select',
                onCountryChange
            );
    }

    input.setAttribute('data-places-bound', 'true');
}

function init(root) {

    var scope = root && root.querySelectorAll ? root : document;
    var formGroups = scope.querySelectorAll('.shipping-address-autocomplete');

    if (!formGroups.length) {
        return;
    }

    for (var i = 0; i < formGroups.length; i++) {
        (function (formGroup) {
            var config = readConfig(formGroup);
            var input = formGroup.querySelector('.shippingAddressOne');
            var formRoot = formGroup.closest('form')
                || formGroup.closest('.shipping-address-block')
                || formGroup.closest('.editAddressForm')
                || formGroup.parentElement;

                 
            if (!config.enabled) {
                return;
            }

            if (!config.apiKey) {
                if (window.console && console.warn) {
                    console.warn('[PlacesAutocomplete] Missing API key in site preference placesAPI');
                }
                return;
            }

            if (!input || !formRoot) {
                return;
            }

            loadGooglePlaces(config.apiKey)
                .then(function () {
                    attachAutocomplete(input, formRoot, config);
                })
                .catch(function (err) {
                    if (window.console && console.warn) {
                        console.warn('[PlacesAutocomplete] Failed to initialize:', err && err.message ? err.message : err);
                    }
                });
        })(formGroups[i]);
    }
}

module.exports = {
    init: init
};
